import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

import { Store } from '@ngrx/store'

import { ICON_GENERATE_STARS_ANIMATED } from '@flowx/designer/shared/ai-illustrations'

import { AiIconsModule } from '../../../../common/icons/ai-icons.module'

@Component({
  selector: 'flx-ai-loader',
  templateUrl: './ai-loader.component.html',
  styleUrls: ['./ai-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AiIconsModule],
})
export class AiLoaderComponent {
  #domSanitizer = inject(DomSanitizer)
  #store = inject(Store)

  title = input<string>(null)
  white = input(true)

  loadingSVG: SafeHtml = this.#domSanitizer.bypassSecurityTrustHtml(ICON_GENERATE_STARS_ANIMATED)
}
